export const RUB_SIGN = '\u20bd';
export const SQUARE_METER_SIGN = 'м²';
export const NBSP = '\u00A0';
